<template>
  <div class="app" v-title data-title="富林印迹-广富林文化遗址公园">
    <component :is="headerComponent" :activeIndex="1" />
    <div class="yj-banner rel">
      <img src="@/assets/images/yj-banner.png" class="db wp100" alt="banner">
      <div class="crumbs-nav df align_center justify_end fa_wh box-border">
        <router-link to="/" class="f16 fw">首页</router-link>
        <img src="@/assets/images/arrow-wh-05.png" class="db w20 ml5 mr5" alt="">
        <router-link to="/pages/yinxiang/index" class="f16 fw">印象富林</router-link>
        <img src="@/assets/images/arrow-wh-05.png" class="db w20 ml5 mr5" alt="">
        <router-link to="/pages/yinxiang/index" class="f16 fw">富林印迹</router-link>
      </div>
      <div class="yj-banner-tit df align_center flex_column justify_center ts fw">
        <div class="f50 ls1 b">印象富林</div>
        <div class="f17 ls3">Impressions of Guangfulin</div>
      </div>
      <div class="yj-nav wp100">
        <div class="yj-nav-item df align_center justify_center">
          <div class="yj-nav-box ">
            <router-link to="/pages/yinxiang/index" class="yj-nav-link db f24">富林印迹</router-link>
          </div>
          <div class="yj-nav-box active">
            <router-link to="/pages/yinxiang/yinxiang-yizhi" class="yj-nav-link db f24">遗址挖掘</router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="yinxiang-yizhi w1200 auto pb15" v-if="artist && artist.ContentText" v-html="artist.ContentText">
    </div>
    <component :is="bottomComponent" />
  </div>
</template>

<script>
import Header from '../../components/header.vue'
import Bottom from '../../components/bottom.vue'
import promotionService from '@/services/client/cont/promotion'

export default {
  name: 'app',
  data () {
    return {
      headerComponent: 'Header',
      bottomComponent: 'Bottom',
      code: 'app-yxfl-yzwj',
      artist: null,
    }
  },
  components: { Header, Bottom,},
  mounted() {
    this.loadData();
  },
  methods:{
    loadData() {
      promotionService.detail(this.code).then(res => {
        if(res.Code == 200) {
          let data = res.Data;
          this.artist = data.Items[0];
        }
      })
    },
  },

}
</script>



// WEBPACK FOOTER //
// src/views/yinxiang/yinxiang-yizhi.vue